// extracted by mini-css-extract-plugin
export var cardExtraPriceInfo = "CardExtraPriceInfo_cardExtraPriceInfo__sRTKt";
export var textPrimary = "CardExtraPriceInfo_textPrimary__kqgvj";
export var rotate = "CardExtraPriceInfo_rotate__Xup0+";
export var dotty = "CardExtraPriceInfo_dotty__enr6v";